module.exports = "pegasus_template/assets/hexline-linkedin.gif";